module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    attrs: {
      "id": "detail"
    }
  }, [_c('div', [_c('van-search', {
    attrs: {
      "shape": "round",
      "background": "#2486ff",
      "placeholder": "能搜出来的银行为可打款银行"
    },
    on: {
      "input": _vm.handleSearch
    },
    model: {
      value: (_vm.searchText),
      callback: function($$v) {
        _vm.searchText = $$v
      },
      expression: "searchText"
    }
  }), _vm._v(" "), (_vm.showDropdown) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "background-color": "rgba(255, 255, 255, 1)",
      "z-index": "10",
      "height": "320px",
      "overflow-y": "auto",
      "width": "95%"
    }
  }, _vm._l((_vm.subBankList), function(item, index) {
    return _c('ul', {
      key: index,
      staticStyle: {
        "padding-bottom": "1rem"
      }
    }, [_c('li', {
      staticStyle: {
        "text-align": "center",
        "line-height": "20px",
        "height": "20px",
        "padding": "0",
        "display": "block"
      }
    }, [_vm._v("\n              " + _vm._s(item.text) + "\n            ")])])
  }), 0) : _vm._e()], 1), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    staticClass: "spanL"
  }, [_vm._v("凭证号")]), _c('span', {
    staticClass: "spanR"
  }, [_vm._v(_vm._s(_vm.userInfo.insuranceNo))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "spanL"
  }, [_vm._v("产品名称")]), _c('span', {
    staticClass: "spanR"
  }, [_vm._v(_vm._s(_vm.userInfo.productName ? (_vm.userInfo.productName.indexOf("A") > -1 ? "学驾易(驾考服务)A" : _vm.userInfo.productName.indexOf("C") > -1 ? "学驾易(驾考服务)C" : "学驾易(驾考服务)") : ""))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "spanL"
  }, [_vm._v("开始日期")]), _c('span', {
    staticClass: "spanR"
  }, [_vm._v(_vm._s(_vm.userInfo.insuranceStartTime))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "spanL"
  }, [_vm._v("结束日期")]), _c('span', {
    staticClass: "spanR",
    staticStyle: {
      "color": "#f60f60"
    }
  }, [_vm._v(_vm._s(_vm.userInfo.insuranceEndTime))])])]), _vm._v(" "), _c('div', {
    staticClass: "user-info-note"
  }, [_vm._v("\n        温馨提示：\n        " + _vm._s(_vm.userInfo.userName) + "学员您好！在操作补偿前，务必先查好开户行支行信息，补偿时必须提供，查询方式打银行卡背面客服电话查询，银行会以短信形式发送，尽量为四大银行，如非四大行可在上方搜索，是否符合收款账户。\n        如在上方搜索框无法匹配到您所填写的银行，请更换本人收款银行。\n      ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "large",
      "type": "info"
    },
    on: {
      "click": _vm.toClaim
    }
  }, [_vm._v("申请补偿")]), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "100%",
      "margin-top": "20px"
    },
    attrs: {
      "size": "large",
      "type": "info"
    },
    on: {
      "click": _vm.goPage
    }
  }, [_vm._v("返回个人信息")]), _vm._v(" "), _c('popup', {
    ref: "popupShows"
  }), _vm._v(" "), _c('ajaxLoading', {
    ref: "loading"
  }), _vm._v(" "), _c('maskPopup', {
    ref: "maskShow"
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "40px",
      "line-height": "40px",
      "display": "flex",
      "justify-content": "space-around"
    }
  }, [_c('a', {
    attrs: {
      "href": "./learn"
    }
  }, [_vm._v("视频教程")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c6ab6cd0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/settlementInfo.vue
// module id = 489
// module chunks = 1